<div fxFlex="100" class="inputs" fxLayout="row wrap">
    <div>
        Total Containers: {{ containersDataSource?.data?.length }}
    </div>
    <div class="setTable w-100">
        <ng-container>
            <mat-table [dataSource]="containersDataSource">
                <!--                <ng-container [matColumnDef]="'charge_description'">-->
                <!--                    <mat-header-cell *matHeaderCellDef> Charge</mat-header-cell>-->
                <!--                    <mat-cell *matCellDef="let data" class="fs-12 ">-->
                <!--                        <div style="display: flex; flex-direction: column; align-items:-->
                <!--                                                        flex-start;">-->
                <!--                                                            <span class="natureChip">-->
                <!--                                                                {{ data.charge_description }}-->
                <!--                                                            </span>-->
                <!--                        </div>-->
                <!--                    </mat-cell>-->
                <!--                </ng-container>-->
                <ng-container [matColumnDef]="'container'">
                    <mat-header-cell *matHeaderCellDef> Container #</mat-header-cell>
                    <mat-cell *matCellDef="let data" class="fs-12 ">
                        <div style="display: flex; flex-direction: column; align-items:
                                                        flex-start;">
                                                            <span class="natureChip">
                                                                {{
                                                                    data.requirement_container?.container ?
                                                                        data.requirement_container?.container?.container_number :
                                                                        'XXXXXXXXXX'
                                                                }}
                                                            </span>
                        </div>
                    </mat-cell>
                </ng-container>
                <ng-container [matColumnDef]="'chargable_days'">
                    <mat-header-cell *matHeaderCellDef> Particulars</mat-header-cell>
                    <mat-cell *matCellDef="let data" class="fs-12 ">
                        <span style="display: flex; flex-direction: column">
                            <span *ngIf="data.per_day == 0">
                                {{ data.chargable_days != 0 ? (data.chargable_days + ' Days') : '' }}
                            </span>
                            <span *ngIf="data.per_day != 0">
                                <mat-chip
                                    class="secondary-chip sleek-chip" style="font-size: 10px;">{{
                                        data.per_day + ' ' + data.currency + '/day * ' + data.chargable_days +
                                        (data.chargable_days < 10 ? ' Day' : ' Days')
                                    }}
                                </mat-chip>
                            </span>
                            <span style="font-size: 10px; color: #f05f25;" *ngIf="data.from_date != null">
                                From: {{ data.from_date | date:'dd MMM, yyyy' }}
                            </span>
                            <span style="font-size: 10px; color: #f05f25;" *ngIf="data.to_date != null">
                                To: {{ data.to_date| date:'dd MMM, yyyy' }}
                            </span>
                        </span>
                    </mat-cell>
                </ng-container>
                <ng-container [matColumnDef]="'total_amount'">
                    <mat-header-cell *matHeaderCellDef> Amount</mat-header-cell>
                    <mat-cell *matCellDef="let data" class="fs-12 ">
                        <span style="display: flex; flex-direction: column">
                            <span>
                                {{ data.total_amount | number: '1.2-2' }} {{ data.currency }}
                            </span>
                        </span>
                    </mat-cell>
                </ng-container>
                <!--                        <ng-container [matColumnDef]="'invoice_status'">-->
                <!--                            <mat-header-cell *matHeaderCellDef> Status</mat-header-cell>-->
                <!--                            <mat-cell *matCellDef="let data" class="fs-12 ">-->
                <!--                                <mat-chip [style.background-color]="'blue'"-->
                <!--                                          style="color:white">-->
                <!--                                    {{ data?.invoice_status == null ? "-" : data?.invoice_status }}-->
                <!--                                </mat-chip>-->
                <!--                            </mat-cell>-->
                <!--                        </ng-container>-->
                <!--                        <ng-container [matColumnDef]="'created_at'">-->
                <!--                            <mat-header-cell *matHeaderCellDef> Created On</mat-header-cell>-->
                <!--                            <mat-cell *matCellDef="let data" class="fs-12 ">-->
                <!--                                <span>-->
                <!--                                    {{ data?.created_at == null ? "-" : (data?.created_at | date: 'dd MMM, yyyy') }}-->
                <!--                                </span>-->
                <!--                            </mat-cell>-->
                <!--                        </ng-container>-->
                <mat-header-row
                    *matHeaderRowDef="containersColumns ; sticky: true "></mat-header-row>
                <mat-row *matRowDef="let row; columns: containersColumns;"
                         [hidden]="containersDataSource.data.length == 0"></mat-row>
            </mat-table>
        </ng-container>
    </div>
</div>
